export default __webpack_public_path__ + "static/media/facebook.db02316b.svg";